import { useQuery } from "@tanstack/react-query";
import { getProjectList } from "../../api/apiCallManager";

const useFLProjectList = () => {
  return useQuery({
    queryKey: ["projectListFL"],
    queryFn: getProjectList,
  });
};

export default useFLProjectList;
